<template>
  <g>
    <path
      d="M20.08 11.4202L16.04 5.77024C15.7 5.29024 15.15 5.00024 14.56 5.00024C13.07 5.00024 12.21 6.68024 13.07 7.89024L16 12.0002L13.07 16.1102C12.2 17.3202 13.07 19.0002 14.56 19.0002C15.15 19.0002 15.71 18.7102 16.05 18.2302L20.09 12.5802C20.33 12.2302 20.33 11.7702 20.08 11.4202Z"
    />
    <path
      d="M13.08 11.4202L9.04998 5.77024C8.69998 5.29024 8.14998 5.00024 7.55998 5.00024C6.06998 5.00024 5.19998 6.68024 6.06998 7.89024L8.99998 12.0002L6.06998 16.1102C5.19998 17.3202 6.06998 19.0002 7.55998 19.0002C8.14998 19.0002 8.70998 18.7102 9.04998 18.2302L13.09 12.5802C13.33 12.2302 13.33 11.7702 13.08 11.4202Z"
    />
  </g>
</template>
